import { MagicLinkLoginPage } from './MagicLinkLoginPage';

export function CoachLoginPage() {
  return <MagicLinkLoginPage persona="coach" />;
}

export default CoachLoginPage;
